import React from 'react';
import clsx from 'clsx';
import { IconTypes, SvgIcon } from 'components/helpers/SvgIcon';
import styles from './SuccessGate.module.scss';

export interface SuccessGateProps {
  title: React.ReactNode;
  description: React.ReactNode;
  button?: React.ReactNode;
  icon?: IconTypes;
  variant?: 'success' | 'underage';
  testId?: string;
}

const SuccessGate = ({
  title,
  description,
  button,
  icon,
  variant = 'success',
  testId,
}: SuccessGateProps) => {
  return (
    <div
      className={clsx(styles.successGateModal, variant === 'underage' && styles.underage)}
      data-testid={testId}
    >
      <div className={styles.successGateWrapper}>
        {icon && (
          <div className={styles.iconWrapper} aria-hidden="true">
            <SvgIcon icon={icon} size="lg" />
          </div>
        )}
        <h1 className={styles.successGateTitle}>{title}</h1>
        <div className={styles.successGateDescription}>{description}</div>
        {button ? <div className={styles.successGateButton}>{button}</div> : null}
      </div>
    </div>
  );
};

export default SuccessGate;
